import { GetAllInspectionsInDto, GetAllInspectionsOutDto } from '../../../types/inspection.dto'

export const GET_ALL_INSPECTIONS = 'GET_ALL_INSPECTIONS'
export const GET_ALL_INSPECTIONS_SUCCESS = 'GET_ALL_INSPECTIONS_SUCCESS'
export const GET_ALL_INSPECTIONS_ERROR = 'GET_ALL_INSPECTIONS_ERROR'
export const RESET_GET_ALL_INSPECTIONS = 'RESET_GET_ALL_INSPECTIONS'

export interface GetAllInspections {
  type: typeof GET_ALL_INSPECTIONS
  payload: GetAllInspectionsOutDto
}

export interface GetAllInspectionsSuccess {
  type: typeof GET_ALL_INSPECTIONS_SUCCESS
  payload: GetAllInspectionsInDto
}

export interface GetAllInspectionsError {
  type: typeof GET_ALL_INSPECTIONS_ERROR
  payload: string | boolean
}

export interface ResetGetAllInspections {
  type: typeof RESET_GET_ALL_INSPECTIONS
  payload: null
}

export interface State {
  data: GetAllInspectionsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllInspections | GetAllInspectionsSuccess | GetAllInspectionsError | ResetGetAllInspections
